export default __webpack_public_path__ + "static/media/profile-page.3a626caf.png";